export default {
  header: {
    business_person: "Business Operator",
  },
};

// operator.layout.header
